import React from 'react';
import CustomTooltip from '@components/ringil3/Tooltip/CustomTooltip';

interface ExpandableInfoAllTagProps {
  id: string;
  onClick: () => void;
  dataTestId?: string;
  tooltipText?: string;
  icon?: React.ReactElement;
}

const ExpandableInfoAllTag: React.FC<ExpandableInfoAllTagProps> = ({
                                                                     id,
                                                                     onClick,
                                                                     dataTestId,
                                                                     tooltipText,
                                                                     icon,
                                                                   }) => {

  const iconWithClass = icon
    ? React.cloneElement(icon, {
      className: `${icon.props.className || ''} flex-shrink-0 w-3 h-3`,
    })
    : null;

  return (
    <div
      id={id}
      data-testid={dataTestId}
      className="inline-flex items-center min-h-[28px] px-2 py-1 border border-solid border-content-brandMedium rounded text-xs tracking-[-0.12px] cursor-pointer transition-all duration-200 hover:bg-content-brandMedium"
      onClick={onClick}
    >
      {tooltipText && <CustomTooltip targetSelector={`#${id}`} content={tooltipText} />}
      {iconWithClass}
    </div>
  );
};

export default ExpandableInfoAllTag;